
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class DimensionalRiftEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             // Jagged rift line
             ctx.beginPath();
             ctx.lineWidth = 10 * scale / (layerIndex + 1);
             ctx.moveTo(-width * 0.5, -height * 0.5);
             const segments = 20;
             for (let i = 0; i <= segments; i++) {
                 const t = i / segments;
                 const x = -width * 0.5 + t * width;
                 const y = -height * 0.5 + t * height + Math.sin(curTime * 5 + i) * 50 * scale;
                 ctx.lineTo(x, y);
             }
             ctx.stroke();
             
             // Energy bleeding out
             ctx.globalAlpha *= 0.3;
             for (let i = 0; i < 5; i++) {
                 ctx.beginPath();
                 ctx.lineWidth = (20 - i * 4) * scale;
                 ctx.moveTo(-width * 0.5, -height * 0.5);
                 for (let j = 0; j <= segments; j++) {
                     const t = j / segments;
                     const x = -width * 0.5 + t * width + Math.sin(curTime * 10 + i + j) * (20 + i * 10);
                     const y = -height * 0.5 + t * height + Math.cos(curTime * 10 + i + j) * (20 + i * 10);
                     ctx.lineTo(x, y);
                 }
                 ctx.stroke();
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
